module.exports = __webpack_public_path__ + "static/img/freeCash.f6d7e6a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freeSign/freeCash.webp
// module id = 4rFT
// module chunks = 0